module.exports = __webpack_public_path__ + "img/ic_foot_hight_10.61f5ad76.png";